import React from 'react';
import axios from 'axios';
import { getLoginPersistanceTimeout } from '../../constants/Constants';
import { Redirect } from 'react-router-dom';
import { useAppDispatch } from '../../store/Hooks';
import { fetchStudent, studentAuthStateSwap, fetchResults } from '../../store/StudentSlice';
import { fetchTeacher, teacherAuthStateSwap } from '../../store/TeacherSlice';
import { StudentData } from '../../store/viewmodels/StudentViewModel';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { setAxiosAuthToken } from '../../utils/AuthServices';
import { fetchFrontPage } from '../../store/FrontPageSlice';


function Login() {
    const dispatch = useAppDispatch()
    const studentData: StudentData = useAppSelector(state => state.studentData)
    const teacherData: TeacherData = useAppSelector(state => state.teacherData)
    const studentAuth = studentData.isAuthenticated
    const teacherAuth = teacherData.isAuthenticated
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [isTeacher, setIsTeacher] = React.useState(false)
    const [isStudent, setIsStudent] = React.useState(false)
    const [isLogged, setIsLogged] = React.useState(false)
    const userId = React.useRef(NaN)
    const isFirstRender = React.useRef(true)
    const [errorClass, setErrorClass] = React.useState("hidden");

    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
        getUserTypeDataToState()
        if (isStudent) {
            dispatch(studentAuthStateSwap(true))
        } else if (isTeacher) {
            dispatch(teacherAuthStateSwap(true))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogged]);

    const handleChange = (event: any) => {
        if (event.target.name === 'email') {
            setEmail(event.target.value)
        } else if (event.target.name === "password") {
            setPassword(event.target.value)
        }
    }

    const getUserTypeDataToState = () => {
        if (isStudent) {
            dispatch(fetchStudent(userId.current))
                .then(() => {
                    dispatch(fetchResults(userId.current))
                }).then(() => {
                    dispatch(fetchFrontPage())
                })
        } else if (isTeacher) { dispatch(fetchTeacher(userId.current)) }
    }

    const handleSubmit = (event: any) => {
        let authURL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/token-auth/' : '/api/token-auth/'
        event.preventDefault();
        axios.post(authURL, {
            username: email,
            password: password
        })
            .then((response) => {
                const auth_token = response.data.token
                const currentDate = new Date();
                const persistanceHours: number = getLoginPersistanceTimeout()
                currentDate.setHours(currentDate.getHours() + persistanceHours); //Determines how long the user will remain logged in even after leaving the site or refreshing it.
                setAxiosAuthToken(auth_token)
                localStorage.setItem('access_token', JSON.stringify(auth_token))
                localStorage.setItem('user_id', response.data.user_id)
                localStorage.setItem('user_type', response.data.user_groups[0].name)
                localStorage.setItem('login_time', JSON.stringify(currentDate))
                userId.current = response.data.user_id
                response.data.user_groups[0].name !== 'Teacher' ? setIsStudent(true) : setIsTeacher(true)
                setIsLogged(true)
                setErrorClass("hidden");
            }, (error) => {
                setIsLogged(false)
                setIsStudent(false)
                setIsTeacher(false)
                setEmail('')
                setPassword('')
                userId.current = NaN
                console.log(error)
                setErrorClass("text-m text-red-500")
            })
    }

    const passResetURL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/password_reset/' : '/api/password_reset/'
    const loginContent = <div className="flex flex-grow mt-20">
        <div className="max-w-2/5 w-full space-y-8 mx-auto">
            <div>
                <img className="mx-auto h-12 w-auto" src="logo_musta.png" alt="Vikke" />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Kirjaudu sisään</h2>
            </div>
            <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                <input type="hidden" name="remember" value="true" />
                <div className="rounded-md shadow-sm -space-y-px">
                    <div>
                        <label htmlFor="email-address" className="sr-only">Sähköposti</label>
                        <input value={email} onChange={handleChange} id="email-address" name="email" type="" autoComplete="email" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Käyttäjätunnus" />
                    </div>
                    <div>
                        <label htmlFor="password" className="sr-only">Salasana</label>
                        <input value={password} onChange={handleChange} id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Salasana" />
                    </div>
                </div>
                <div>
                    <button type="submit" value="Submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                            <svg className="h-5 w-5 text-teal-500 group-hover:text-teal-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                            </svg>
                        </span>
                        Kirjaudu
                    </button>
                </div>
            </form>
            <div className="">
                <a href="/register">Rekisteröidy</a>
            </div>
            <div className="">
                <a href={passResetURL}>Unohditko salasanasi?</a>
            </div>
            <div className={errorClass}>Kirjautuminen epäonnistui. Tarkista käyttäjätunnus ja salasana. </div>
        </div>
    </div>

    const routingLogic = () => {
        if (studentAuth) {
            return <Redirect to='/student/' />
        } else if (teacherAuth) {
            return <Redirect to='/teacher/' />
        } else {
            return loginContent
        }
    }
    let routeView: JSX.Element = routingLogic()

    return (
        <>{routeView}</>
    )
}


export default Login;